import {
  resource,
} from 'common/store/reducer';

import {
  NAMESPACE,
} from './actions';

export default resource.factory(NAMESPACE);
